import { render, staticRenderFns } from "./InsuranceProvidersForm.vue?vue&type=template&id=3e232108"
import script from "./InsuranceProvidersForm.vue?vue&type=script&lang=js"
export * from "./InsuranceProvidersForm.vue?vue&type=script&lang=js"
import style0 from "./InsuranceProvidersForm.vue?vue&type=style&index=0&id=3e232108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports